<template>
    <div @click="toggleInfoModal()" data-bs-toggle="modal" data-bs-target="#infoModal">
        <small class="text-secondary fw-bold text-decoration-underline cursor-pointer">What's this?</small>
    </div>
</template>

<script>
    export default {
        methods: {
            toggleInfoModal() {
                var text = '<p>For a small environmental disposal fee, we responsibly dispose of all waste from your car in line with government regulations. We work with registered professionals to store, collect, recycle, or safely dispose of waste, ensuring full compliance with current laws.</p>';

                this.emitter.emit('openInfoModal', {heading: 'Environmental fee', text: text});
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>